import { BLOCKED_IPS_PATH } from '../../../../constants'
import AbstractService from '../../../../services/AbstractService'

import { GetBlockedIpsResponse, UpdatateBlockedIpResponse } from './types'

class BlockedIpApiClass extends AbstractService {
  getAll = (search?: string) =>
    this.request<GetBlockedIpsResponse>(
      `${BLOCKED_IPS_PATH}${search ? `?search=${encodeURIComponent(search)}` : ''}`,
    )

  update = (id: number, isActive: boolean) =>
    this.request<UpdatateBlockedIpResponse>(`${BLOCKED_IPS_PATH}/${id}`, 'patch', false, {
      isActive,
    })
}

export const BlockedIpApi = new BlockedIpApiClass()
